export const Details = {
    LOAD_SERVICE_DETAIL: "GET_SERVICE_DETAILS_SUCCESS",
    GET_REQUIRED_INPUTS: "GET_REQUIRED_INPUTS_FOR_SERVICE",
    CLEAR_CURRENT_SERVICE_DETAIL: "CLEAR_CURRENT_SERVICE_DETAILS",
    DELETE_SERVICE_WARNING: "DELETE_WARNING_FOR_DATA_SERVICE",
}
